import request from '@/utils/request'
// 註冊-新增使用者
export function AccountSignUp(data) {
  return request({
    url: '/api/web/account/sign-up',
    method: 'post',
    data
  })
}
// (註冊)手機號碼/email是否使用過
export function SendSignUpOTP(data) {
  return request({
    url: '/api/web/account/sign-up-otp-send',
    method: 'post',
    data
  })
}
// (註冊)驗證手機號碼/email是否與驗證碼符合
export function IdvOTP(data) {
  return request({
    url: '/api/web/account/idv-otp',
    method: 'post',
    data
  })
}
// 忘記密碼 已存在身份驗證+發送OTP
export function GetAccountVerifyOTPSend(data) {
  return request({
    url: '/api/web/account/verify-otp-send',
    method: 'post',
    data
  })
}
// 忘記密碼 重設新密碼
export function GetAccountIdvChangePwd(data) {
  return request({
    url: '/api/web/account/idv-change-pwd',
    method: 'post',
    data
  })
}
// 使用者登入
export function AccountLogIn(data) {
  return request({
    url: '/api/web/account/login',
    method: 'post',
    data
  })
}
// 使用者登出
export function AccountLogOut() {
  return request({
    url: '/api/web/account/logout',
    method: 'post'
  })
}
// 
export function AccountRefreshToken(refreshToken) {
  return request({
    url: '/api/web/account/refresh-token',
    method: 'put',
    params: {
      refreshToken
    }
  })
}
// 註冊-修改密碼
export function GetAccountChangePWD(data) {
  return request({
    url: '/api/web/account/change-pwd',
    method: 'post',
    data
  })
}
// 更新-所屬場館
export function GetAccountChangeSite(data) {
  return request({
    url: '/api/web/account/change-site',
    method: 'post',
    data
  })
}